import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from './notification.service';
import { firstValueFrom } from 'rxjs';
import {
  BackendErrorInterface,
  GetDireccionesContratosInterface,
  GetDireccionesCuentasInterface,
  GetEntidadesInterface,
  GetLogInfoInterface,
  GetTxInfoInterface,
} from '../interfaces/backend.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BackendService {
  backendUrl: string = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private notificationService: NotificationService
  ) {}

  hello():Observable<any> {
    return this.http.get(this.backendUrl, { responseType: 'text' });
  }
  helloResource():Observable<any> {

    return this.http.get(this.backendUrl , { responseType: 'text' });

  }

 
  getTxInfo(
    from: string | null,
    to: string | null,
    fromBlock: number | null,
    toBlock: number | null
  ): Observable<GetTxInfoInterface | BackendErrorInterface> {
    const body = {
      from: from !== '' ? from : null,
      to: to !== '' ? to : null,
      fromBlock,
      toBlock,
    };
    console.log('BODY: ', body);
    return this.http.post<GetTxInfoInterface | BackendErrorInterface>(
      this.backendUrl +
        '/olimpoRuntimeOnline/RestService/v2/BLKCBACKTgetTxInfo',
      body
    );
  }

  getLogInfo(
    from: string | null,
    to: string | null,
    fromBlock: number | null,
    toBlock: number | null
  ): Observable<GetLogInfoInterface | BackendErrorInterface> {
    const body = {
      from: from !== '' ? from : null,
      to: to !== '' ? to : null,
      fromBlock,
      toBlock,
    };
    return this.http.post<GetLogInfoInterface | BackendErrorInterface>(
      this.backendUrl +
        '/olimpoRuntimeOnline/RestService/v2/BLKCBACKTgetLogInfo',
      body
    );
  }

  getEntidades(): Observable<GetEntidadesInterface | BackendErrorInterface> {
    return this.http.post<GetEntidadesInterface | BackendErrorInterface>(
      this.backendUrl +
        '/olimpoRuntimeOnline/RestService/v2/BLKCBACKTgetEntidades',
      {}
    );
  }

  getDireccionesCuentas(
    direccion: string | null,
    entidad: string | null
  ): Observable<GetDireccionesCuentasInterface | BackendErrorInterface> {
    const body = {
      direccion: direccion !== '' ? direccion : null,
      entidad: entidad !== '' ? entidad : null,
    };
    return this.http.post<
      GetDireccionesCuentasInterface | BackendErrorInterface
    >(
      this.backendUrl +
        '/olimpoRuntimeOnline/RestService/v2/BLKCBACKTgetCuentas',
      body
    );
  }
  getDireccionesContratos(
    direccion: string | null,
    entidad: string | null
  ): Observable<GetDireccionesContratosInterface | BackendErrorInterface> {
    const body = {
      direccion: direccion !== '' ? direccion : null,
      entidad: entidad !== '' ? entidad : null,
    };
    return this.http.post<
      GetDireccionesContratosInterface | BackendErrorInterface
    >(
      this.backendUrl +
        '/olimpoRuntimeOnline/RestService/v2/BLKCBACKTgetContratos',
      body
    );
  }

  postEntidad(nombre: string, ssoUser: string): Observable<any> {
    const body = {
      nombre,
      ssoUser,
    };
    return this.http.post<any>(
      this.backendUrl +
        '/olimpoRuntimeOnline/RestService/v2/BLKCBACKTnuevaEntidad',
      body
    );
  }

  postDireccionCuenta(
    direccion: string,
    nombre: string,
    entidad: string
  ): Observable<any> {
    const body = {
      direccion,
      nombre,
      entidad,
    };
    return this.http.post<any>(
      this.backendUrl +
        '/olimpoRuntimeOnline/RestService/v2/BLKCBACKTnuevaCuenta',
      body
    );
  }

  postDireccionContrato(
    direccion: string,
    nombre: string,
    entidad: string,
    codigo: string
  ): Observable<any> {
    const body = {
      direccion,
      nombre,
      entidad,
      codigo,
    };
    return this.http.post<any>(
      this.backendUrl +
        '/olimpoRuntimeOnline/RestService/v2/BLKCBACKTnuevoContrato',
      body
    );
  }
}
